// Module
var code = `{{#headline}}
<div class="dk-col-small-12">
   <div class="headline-wrap dk-grid dk-small-align-justify">
      <h{{headlineLevel2}} class="headline dk-col-small-12 dk-col-medium-shrink">
         {{headline}}{{#resultsCount}}<span class="vertical-separator">|</span><span class='count'>{{resultsCount}}</span>{{/resultsCount}}{{#reset}}<a class="reset dk-hide-for-small dk-show-for-medium" href="#">{{reset}}</a>{{/reset}}
      </h{{headlineLevel2}}>
      <div class="dk-col-small-12 dk-col-medium-shrink">
         <div class="pagination-wrapper">
            {{#pagination}}
               {{#no-link}}
                  <span class="{{class}}">{{{text}}}</span>
               {{/no-link}}
               {{^no-link}}
                  <a href="{{url}}" data-pagination="{{page}}" class="{{class}}" title="{{title}}">{{{text}}}</a>
               {{/no-link}}
            {{/pagination}}
         </div>
      </div>
         {{#sorting}}
            <div class="dk-col-small-12 dk-col-medium-shrink">
               <div class="select-wrapper sorting-wrapper">
                  <select id="sorting" size="1">
                     {{#options}}
                        <option value="{{sortValue}}|{{sortDirection}}" {{attr}}>{{text}}</option>
                     {{/options}}
                  </select>
               </div>
            </div>
         {{/sorting}}
   </div>
</div>
{{/headline}}
<div class="dk-col-small-12">
   <div class="dk-grid">
   {{#renderNoResultsHint}}
      <div class="dk-col-small-12">
         {{#noResultsText}}
         <strong>{{noResultsText}}</strong>
         {{/noResultsText}}
      </div>
   {{/renderNoResultsHint}}
   {{#results}}
      <div class="result dk-col-small-12" data-object-id="{{objectId}}">
         <div class="dk-grid">
            <div  class="cell dk-col-small-3">
               <img src="{{imagePath}}" width="300">
            </div>
            <div class="cell dk-col-small-9">
               <h{{headlineLevel3}} class="headline">
                  <div>{{name}}</div>
               </h{{headlineLevel3}}>
               {{#description}}
                  <div class="rte">
                     <p>{{{description}}}</p>
                  </div>
               {{/description}}
               <a href="{{detailUri}}" title="{{moreText}}: {{name}}">
                  {{detailLinkText}}
               </a>
            </div>
         </div>
      </div>
   {{/results}}
   </div>
   <div class="dk-grid dk-small-align-center">
      <div class="dk-col-small-12 dk-col-medium-shrink">
         <div class="pagination-wrapper">
            {{#pagination}}
               {{#no-link}}
                  <span class="{{class}}">{{{text}}}</span>
               {{/no-link}}
               {{^no-link}}
                  <a href="{{url}}" data-pagination="{{page}}" class="{{class}}" title="{{title}}">{{{text}}}</a>
               {{/no-link}}
            {{/pagination}}
         </div>
      </div>
   </div>
</div>`;
// Exports
module.exports = code;